import { send } from '../../../../../../src/network';
import { type PaginatedCustomerPairingRatingDetailList } from '../../../../../../src/types/PaginatedCustomerPairingRatingDetailList';

type Params = {
  limit?: number;
  offset?: number;
  customer_id: number;
};

export async function getApiV2CustomersCustomerIdPairingRatings(
  params: Params
) {
  const queryParams = new URLSearchParams();

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  return await send<PaginatedCustomerPairingRatingDetailList>({
    path: `/api/v2/customers/${params.customer_id}/pairing_ratings/`,
    method: 'GET',
    query: queryParams,
  });
}
